import { useState, useEffect } from "react";
import { ReactTransliterate } from "react-transliterate";
import editIcon from "../../assests/icons/edit.jpg";
import deleteIcon from "../../assests/icons/delete.jpg";
import publishIcon from "../../assests/icons/publish.png";
import { getAuth, isAdmin, isApprover, isPublisher } from "../utils/auth.js";
import parse from "html-react-parser";
import { getPhotoGalleryTypes } from "../../network/lib/masterData.js";
import { showHideLoader, processImage } from "../utils/helper.js";
import {
  photoTypeObject,
  save
} from "../../network/lib/photoType.js";

function PhotoType({ user }) {
  const [photoGalleryTypes, setPhotoGalleryTypes] = useState();
  const [titleType, setTitleType] = useState("1");
  const [previewTitleType, setPreviewTitleType] = useState("1");
  const [liveTitleType, setLiveTitleType] = useState("1");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState("");
  const [previewData, setPreviewData] = useState();
  const [liveData, setLiveData] = useState();
  const [id, setId] = useState(0);
  const admin = isAdmin(user?.roleId);
  const approver = isApprover(user.roleId);
  const publisher = isPublisher(user?.roleId);

  useEffect(() => {
    !photoGalleryTypes && populatePhotoGalleryTypes();
  }, []);

  const populatePhotoGalleryTypes = () => {
    getPhotoGalleryTypes().then((res) => {
      if (res.status == 200) {
        setPhotoGalleryTypes(res.data);
      }
    });
  };

  const setToDefault = () => {
    setTitleType("1");
    setDescription("");
    setImage("");
    setId(0);
    setPreviewData(undefined);
    setLiveData(undefined);
  };

  const handleCancel = (e) => {
    e.preventDefault();
    resetMessage();
    setToDefault();
  };

  const resetMessage = () => {
    let message = document.getElementById("message");
    message.innerHTML = "";
    message.classList.replace("success", "alert");
    return message;
  };

  const handleEdit = (e) => {
    e.preventDefault();
    resetMessage();

    let dataParams = e.target.getAttribute("data-params");
    if (dataParams) {
      let params = JSON.parse(dataParams);
      setId(params.id);
      setTitleType(params.titleId);
      setDescription(params.description);
      setImage(params.image);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let message = resetMessage();

    setLiveData(undefined);
    setPreviewData(undefined);

    if (description == "") {
      message.innerHTML = "Please provide Content";
    } else {
      showHideLoader(true);

      photoTypeObject.id = id;
      photoTypeObject.photoTypeName = description;
      photoTypeObject.userName = user.userName;

      if (id == 0) {
        save(photoTypeObject).then((res) => {
          if (res.status == 200 && res.data) {
            message.classList.replace("alert", "success");
            message.innerHTML = "Data saved successfully!!!";
            setToDefault();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
          showHideLoader();
        });
      } 
    }
  };

  const fetchPreviewData = (titleType) => {
    showHideLoader(true);
  };

  const handlePreviewData = (e) => {
    e.preventDefault();
    resetMessage();
    setPreviewTitleType("1");
    fetchPreviewData("1");
  };

  const fetchLiveData = (titleType) => {
    showHideLoader(true);
  };

  const handleLiveData = (e) => {
    e.preventDefault();
    resetMessage();
    setLiveTitleType("1");
    fetchLiveData("1");
  };

  const handleDeletePreview = (e) => {
    e.preventDefault();
  };

  const handleDeleteLive = (e) => {
    e.preventDefault();
  };

  const handlePublish = (e) => {
    e.preventDefault();
    let message = resetMessage();

    let params = e.target.getAttribute("data-params");
    if (params) {
      photoTypeObject.id = parseInt(params);
      photoTypeObject.userName = user.userName;
    }
  };

  const handleImage = (e) => {
    processImage(e.target.files[0], resetMessage(), setImage);
  };

  const contents = (
    <>
      <table>
        <tbody>
          <tr>
            <th align="center" colSpan="4">
              Photo type
            </th>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Photo Type Name</span>
            </td>
            <td colSpan={3}>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="5" cols="107" />
                )}
                value={description}
                onChangeText={(text) => {
                  setDescription(text);
                }}
                lang="mr"
              />
            </td>
          </tr>
          <tr>
            <td colSpan={2}></td>
            <td style={{ textAlign: "right", paddingRight: "34px" }}>
              <input
                className="btn"
                type="submit"
                value="Cancel"
                id="btnCancel"
                onClick={handleCancel}
              />
              &nbsp;&nbsp;
              <input
                className="btn"
                type="submit"
                value="Submit"
                id="btnSubmit"
                onClick={handleSubmit}
              />
            </td>
            <td></td>
          </tr>
          <tr>
            <td colSpan="4" style={{ textAlign: "center" }}>
              <div
                id="message"
                className="alert"
                style={{ textAlign: "center" }}
              ></div>
            </td>
          </tr>
          {/* <tr>
            <td></td>
            <td colSpan={2}>
              <input
                className="btn"
                type="submit"
                style={{ float: "left" }}
                value="View Preview"
                id="btnPreviewData"
                onClick={handlePreviewData}
              />
              &nbsp;&nbsp;
              <input
                className="btn"
                type="submit"
                value="View Live"
                id="btnLiveData"
                onClick={handleLiveData}
              />
            </td>
            <td></td>
          </tr> */}
        </tbody>
      </table>
      {previewData && (
        <table className="alternate-row">
          <thead>
            <tr>
              <th align="center" colSpan={admin ? 6 : approver ? 5 : 4}>
                Preview
              </th>
            </tr>
            <tr align="center">
              <td colSpan={admin ? 6 : approver ? 5 : 4}>
                <span>Title: </span>
                {photoGalleryTypes && (
                  <select
                    onChange={(e) => {
                      setPreviewTitleType(e.target.value);
                      fetchPreviewData(e.target.value);
                    }}
                    value={previewTitleType}
                    style={{ width: "322px" }}
                  >
                    {photoGalleryTypes.map((x, i) => (
                      <option key={i} value={x.id}>
                        {x.name}
                      </option>
                    ))}
                  </select>
                )}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr align="center">
              {publisher && (
                <td style={{ textAlign: "center" }}>
                  <u>Publish</u>
                </td>
              )}
              <td>
                <u>Title</u>
              </td>
              <td>
                <u>Description</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>Image</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>Edit</u>
              </td>
              {admin && (
                <td style={{ textAlign: "center" }}>
                  <u>Delete</u>
                </td>
              )}
            </tr>
            {previewData.length > 0 ? (
              previewData.map((x, i) => (
                <tr key={i + 1} align="center">
                  {publisher && (
                    <td style={{ textAlign: "center" }}>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handlePublish}
                        src={publishIcon}
                        alt="Publish"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                  <td>{x.title}</td>
                  <td>{x.description}</td>
                  <td style={{ textAlign: "center" }}>
                    {x.image &&
                      parse(`<img src=${x.image}  style="width: 60px"/>`)}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <img
                      className="handle"
                      data-params={JSON.stringify(x)}
                      onClick={handleEdit}
                      src={editIcon}
                      alt="Edit"
                      border="0px"
                      style={{ width: "20px", height: "20px" }}
                    />
                  </td>
                  {admin && (
                    <td style={{ textAlign: "center" }}>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handleDeletePreview}
                        src={deleteIcon}
                        alt="Delete"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={admin ? 6 : approver ? 5 : 4}
                  style={{ textAlign: "center" }}
                >
                  No Data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      {liveData && (
        <table className="alternate-row">
          <thead>
            <tr>
              <th align="center" colSpan={admin ? 4 : 3}>
                Live
              </th>
            </tr>
            <tr align="center">
              <td colSpan={admin ? 4 : 3}>
                <span>Title: </span>
                {photoGalleryTypes && (
                  <select
                    onChange={(e) => {
                      setLiveTitleType(e.target.value);
                      fetchLiveData(e.target.value);
                    }}
                    value={liveTitleType}
                    style={{ width: "322px" }}
                  >
                    {photoGalleryTypes.map((x, i) => (
                      <option key={i} value={x.id}>
                        {x.name}
                      </option>
                    ))}
                  </select>
                )}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr align="center">
              <td>
                <u>Title</u>
              </td>
              <td>
                <u>Description</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>Image</u>
              </td>
              {admin && (
                <td style={{ textAlign: "center" }}>
                  <u>Delete</u>
                </td>
              )}
            </tr>
            {liveData.length > 0 ? (
              liveData.map((x, i) => (
                <tr key={i + 1} align="center">
                  <td>{x.title}</td>
                  <td>{x.description}</td>
                  <td style={{ textAlign: "center" }}>
                    {x.image &&
                      parse(`<img src=${x.image}  style="width: 60px"/>`)}
                  </td>
                  {admin && (
                    <td style={{ textAlign: "center" }}>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handleDeleteLive}
                        src={deleteIcon}
                        alt="Delete"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={admin ? 4 : 3} style={{ textAlign: "center" }}>
                  No Data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </>
  );

  return contents;
}

export default PhotoType;
